module.exports = __webpack_public_path__ + "static/media/anylitics.64727476.svg";